import script from "./Tooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tooltip.vue?vue&type=script&lang=ts&setup=true"

import "./Tooltip.vue?vue&type=style&index=0&id=5bb7b170&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb7b170"]])

export default __exports__